'use strict';

const Backbone = require('backbone');
require('backbone.stickit');
Backbone.Validation = require('backbone-validation');
const Mn = require('backbone.marionette');
const Dialog = require('common/util/dialog');
const ModalTemplate = require('balus/ui/template/body/user-email-activation/modal/user-email-add-request-view.hbs');
const Ajax = require('common/infra/ajax');
const i18n = require('i18next');


const UserEmailRequestModel = Backbone.Model.extend({
    defaults: {
        emailAddress: '',
        showForm: true,
        success: false,
        failure: false,
    },

    validation: {
        emailAddress: [
            {
                required: true,
                msg: 'balus_template_body_user_email_activation:modal.input.email.validation.required'
            },
            {
                // {1}@{2}.{3} のメールアドレスっぽい形式であることを確認する
                pattern: /^[^@]+@[^.]+\..+$/,
                msg: 'balus_template_body_user_email_activation:modal.input.email.validation.invalid'
            }
        ]
    }
});



const UserEmailAddRequestModal = Mn.View.extend({
    template: ModalTemplate,

    ui: {
        form: 'form',
        alertMessage: '.alert-message'
    },

    bindings: {
        'input.emailAddress': 'emailAddress'
    },

    modelEvents: {
        'change:emailAddress': 'changeEmailAddress'
    },

    initialize: function() {
        this.model = new UserEmailRequestModel();
    },

    onRender: function() {
        this.stickit(this.model);
        Backbone.Validation.bind(this);

        return this;
    },

    changeEmailAddress: function() {
        if (this.model.get('emailAddress') && this.model.isValid(true)) {
            this.trigger('formFilled');
        } else {
            this.trigger('formEmpty');
        }
    },

    save: function() {
        const emailAddress = this.model.get('emailAddress');
        const payload = {
            emailAddress: emailAddress
        };

        this.clearAlertMessage();

        return Ajax.POST(`/api/my/emails`, payload);
    },

    onSuccess: function(callback) {
        Dialog.alert({
            text: i18n.t('balus_template_body_user_email_activation:modal.message.success.dialog', {
                email_address: this.model.get('emailAddress')
            }),
            okCallback: () => {
                callback.call();
            }
        });
    },

    onFailed: function(response) {
        let suffix = 'InternalServerError';
        if (response && response.type === 'InvalidEmailAddressFormat') {
            suffix = response.type;
        }
        const message = i18n.t(`balus_template_body_user_email_activation:modal.message.failed.${suffix}`);
        this.setAlertMessage(message);
    },

    setAlertMessage: function (message) {
        this.ui.alertMessage.html(message);
    },

    clearAlertMessage: function () {
        this.ui.alertMessage.html('');
    }
});

module.exports = UserEmailAddRequestModal;



// WEBPACK FOOTER //
// ./balus/ui/view/body/user-email-activation/modal/user-email-add-request-view.js